// import React, { useState, useEffect } from 'react';
// import {
//   TextField, Button, Box, Typography, Container, Alert,
//   Checkbox, FormControlLabel, Dialog, DialogTitle,
//   DialogContent, DialogContentText, DialogActions
// } from '@mui/material';
// import axios from 'axios';
// import { useAuth } from '../../AuthContext';
// import Header1 from '../Header/Header1';
// import Footer2 from '../Footer/Footer2';
// import ExpertAvailability from './ExpertAvailability';

// const API_URL = process.env.REACT_APP_API_URL;

// const ExpertOnboarding = () => {
//   const { userId } = useAuth();

//   const [formData, setFormData] = useState({
//     designation: '',
//     areas_of_expertise: '',
//     about: ''
//   });

//   const [charCounts, setCharCounts] = useState({
//     designation: 0,
//     areas_of_expertise: 0,
//     about: 0
//   });

//   const [agreementChecked, setAgreementChecked] = useState(false);
//   const [successMsg, setSuccessMsg] = useState('');
//   const [errorMsg, setErrorMsg] = useState('');
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [existingExpert, setExistingExpert] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//    const [consultationFee, setConsultationFee] = useState(300);

//   /** 🔹 Contact handling states */
//   const [contactDialogOpen, setContactDialogOpen] = useState(false);
//   const [contact, setContact] = useState('');
//   const [pendingSubmit, setPendingSubmit] = useState(false);

//   const charLimits = {
//     designation: 100,
//     areas_of_expertise: 500,
//     about: 1000
//   };

//   /** 🔹 Fetch expert info */
//   useEffect(() => {
//     const fetchExpert = async () => {
//       try {
//         const res = await axios.post(`${API_URL}/api/experts/check/`, {
//           user_id: userId
//         });

//         const expert = res.data;
//         setExistingExpert(expert);
//          setConsultationFee(expert.consultation_fee || 500);
//         setFormData({
//           designation: expert.designation || '',
//           areas_of_expertise: expert.areas_of_expertise || '',
//           about: expert.about || ''
//         });

//         setCharCounts({
//           designation: expert.designation?.length || 0,
//           areas_of_expertise: expert.areas_of_expertise?.length || 0,
//           about: expert.about?.length || 0
//         });

//       } catch (err) {
//         if (err.response?.status === 404) {
//           setExistingExpert(null);
//         } else {
//           setErrorMsg('Error fetching expert data.');
//         }
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchExpert();
//   }, [userId]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//     setCharCounts(prev => ({ ...prev, [name]: value.length }));
//   };

//   /** 🔹 First step submit */
//   const handleFormSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const res = await axios.post(`${API_URL}/api/user/check-contact/`, {
//         user_id: userId
//       });

//       if (!res.data.has_contact) {
//         setPendingSubmit(true);
//         setContactDialogOpen(true);
//         return;
//       }

//       setDialogOpen(true);
//     } catch {
//       setErrorMsg('Unable to verify contact information.');
//     }
//   };

//   /** 🔹 Save contact */
//   const handleSaveContact = async () => {
//     if (!contact.trim()) return;

//     try {
//       await axios.post(`${API_URL}/api/user/update-contact/`, {
//         user_id: userId,
//         contact
//       });

//       setContactDialogOpen(false);

//       if (pendingSubmit) {
//         setPendingSubmit(false);
//         setDialogOpen(true);
//       }
//     } catch {
//       setErrorMsg('Failed to save contact.');
//     }
//   };

//   /** 🔹 Final expert submit */
//   const handleConfirmSubmit = async () => {
//     setDialogOpen(false);

//     try {
//       const payload = { ...formData, user_id: userId ,  consultation_fee: consultationFee
// };

//       if (existingExpert) {
//         await axios.put(`${API_URL}/api/experts/update/`, payload);
//         setSuccessMsg('Your expert profile was updated successfully.');
//       } else {
//         await axios.post(`${API_URL}/api/experts/create/`, payload);
//         setSuccessMsg('Request submitted! Admin will review your application.');
//       }

//       setErrorMsg('');
//       setExistingExpert({ ...payload, status: existingExpert?.status || 'pending' });

//     } catch {
//       setErrorMsg('Something went wrong. Please try again.');
//     }
//   };

//   if (isLoading) {
//     return <Typography sx={{ mt: 4, textAlign: 'center' }}>Loading...</Typography>;
//   }

//   const canEdit = !existingExpert || ['pending', 'approved'].includes(existingExpert.status);

//   return (
//     <div>
//       <Header1 />
      
//       <Container maxWidth="sm" sx={{ minHeight: '100vh', background: 'radial-gradient(circle at top, #1b1b2b 0%, #000000 100%)', }}>

//         <Typography
//           variant="h3"
//           align="center"
//           sx={{
//             // mt: 10,
//             letterSpacing: 7,
//             backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
//             WebkitBackgroundClip: 'text',
//             color: 'transparent'
//           }}
//         >
//           Expert Space
//         </Typography>

        
//     {/* 🔹 BEFORE APPROVAL → ONLY FEE */}
// {(!existingExpert || existingExpert.status !== "approved") && (
//   <Box sx={{ mt: 3 }}>
//     <Typography variant="h6">Consultation Pricing</Typography>

//     <TextField
//       label="1 Hour Consultation Fee (₹)"
//       type="number"
//       value={consultationFee}
//       onChange={(e) => setConsultationFee(e.target.value)}
//       fullWidth
//       sx={{ mt: 2 }}
//     />
//   </Box>
// )}

// {/* 🔹 AFTER APPROVAL → FULL FEATURE */}
// {existingExpert?.status === "approved" && (
//   <ExpertAvailability
//     consultationFee={consultationFee}
//     setConsultationFee={setConsultationFee}
//   />
// )}

//      {/* <ExpertAvailability
//   consultationFee={consultationFee}
//   setConsultationFee={setConsultationFee}
// /> */}
    

//         {successMsg && <Alert severity="success">{successMsg}</Alert>}
//         {errorMsg && <Alert severity="error">{errorMsg}</Alert>}

//         <Box component="form" onSubmit={handleFormSubmit} sx={{ mt: 3 }}>

//           <TextField
//             name="designation"
//             label="Current Designation"
//             fullWidth
//             required
//             value={formData.designation}
//             onChange={handleChange}
//             inputProps={{ maxLength: charLimits.designation }}
//             helperText={`${charCounts.designation}/${charLimits.designation}`}
//             sx={{ mb: 2 }}
//             disabled={!canEdit}
//           />

//           <TextField
//             name="areas_of_expertise"
//             label="Areas of Expertise"
//             fullWidth
//             required
//             multiline
//             rows={3}
//             value={formData.areas_of_expertise}
//             onChange={handleChange}
//             inputProps={{ maxLength: charLimits.areas_of_expertise }}
//             helperText={`${charCounts.areas_of_expertise}/${charLimits.areas_of_expertise}`}
//             sx={{ mb: 2 }}
//             disabled={!canEdit}
//           />

//           <TextField
//             name="about"
//             label="About You"
//             fullWidth
//             required
//             multiline
//             rows={4}
//             value={formData.about}
//             onChange={handleChange}
//             inputProps={{ maxLength: charLimits.about }}
//             helperText={`${charCounts.about}/${charLimits.about}`}
//             sx={{ mb: 2 }}
//             disabled={!canEdit}
//           />

//           {canEdit && (
//             <>
//               <FormControlLabel
//                 control={
//                   <Checkbox checked={agreementChecked} onChange={(e) => setAgreementChecked(e.target.checked)} />
//                 }
//                 label="I agree to the Expert User Agreement"
//               />

//               <Button
//                 type="submit"
//                 variant="contained"
//                 fullWidth
//                 disabled={!agreementChecked}
//               >
//                 {existingExpert ? 'Update Info' : 'Submit Request'}
//               </Button>
//             </>
//           )}
//         </Box>

//         {/* 🔹 Contact Dialog */}
//         <Dialog open={contactDialogOpen}>
//           <DialogTitle>Contact Required</DialogTitle>
//           <DialogContent>
//             <DialogContentText>
//               Please provide your contact number to continue.
//             </DialogContentText>
//             <TextField
//               fullWidth
//               label="Contact Number"
//               value={contact}
//               onChange={(e) => setContact(e.target.value)}
//               sx={{ mt: 2 }}
//             />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setContactDialogOpen(false)}>Cancel</Button>
//             <Button onClick={handleSaveContact} variant="contained">
//               Save & Continue
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* 🔹 Confirmation Dialog */}
//         <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
//           <DialogTitle>Confirm Submission</DialogTitle>
//           <DialogContent>
//             <DialogContentText>
//               Are you sure you want to proceed?
//             </DialogContentText>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
//             <Button onClick={handleConfirmSubmit} variant="contained">
//               Confirm
//             </Button>
//           </DialogActions>
//         </Dialog>

//       </Container>
//       <Footer2 />
//     </div>
//   );
// };

// export default ExpertOnboarding;


// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Container,
//   TextField,
//   Button,
//   Typography,
//   Grid,
//   Alert,
//   Divider,
//   Paper,
// } from "@mui/material";
// import axios from "axios";
// import { useAuth } from "../../AuthContext";
// import Header1 from "../Header/Header1";
// import Footer2 from "../Footer/Footer2";
// import ExpertAvailability from "./ExpertAvailability";

// const API_URL = process.env.REACT_APP_API_URL;

// const ExpertOnboarding = () => {
//   const { userId } = useAuth();

//   const [formData, setFormData] = useState({
//     designation: "",
//     areas_of_expertise: "",
//     about: "",
//   });

//   const [existingExpert, setExistingExpert] = useState(null);
//   const [consultationFee, setConsultationFee] = useState(300);
//   const [agreementChecked, setAgreementChecked] = useState(false);
//   const [successMsg, setSuccessMsg] = useState("");
//   const [errorMsg, setErrorMsg] = useState("");
//   const [isLoading, setIsLoading] = useState(true);
//   const [linkedinVerified, setLinkedinVerified] =
//   useState(false);

// const [linkedinId, setLinkedinId] =
//   useState(null);

// const [linkedinPicture, setLinkedinPicture] =
//   useState(null);

//   useEffect(() => {
//     const fetchExpert = async () => {
//       try {
//         const res = await axios.post(`${API_URL}/api/experts/check/`, {
//           user_id: userId,
//         });

//         const expert = res.data;
//         setExistingExpert(expert);
//         setConsultationFee(expert.consultation_fee || 300);

//         setFormData({
//           designation: expert.designation || "",
//           areas_of_expertise: expert.areas_of_expertise || "",
//           about: expert.about || "",
//         });
//       } catch (err) {
//         if (err.response?.status !== 404) {
//           setErrorMsg("Error fetching data");
//         }
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchExpert();
//   }, [userId]);

//   const isApproved = existingExpert?.status === "approved";

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSaveFee = () => {
//     setSuccessMsg("Fee saved successfully");
//   };

// const handleLinkedInExpertVerification =
//   async () => {

//     try {

//       const linkedinData =
//         JSON.parse(
//           localStorage.getItem(
//             "linkedin_data"
//           )
//         );

//       if (!linkedinData) {

//         setErrorMsg(
//           "Please login with LinkedIn first"
//         );

//         return;
//       }

//       await axios.post(
//         `${API_URL}/api/experts/linkedin-verify/`,
//         {

//           user_id: userId,

//           linkedin_id:
//             linkedinData.linkedin_id,

//           profile_picture:
//             linkedinData.profile_picture,

//           name:
//             linkedinData.name,

//           email:
//             linkedinData.email,
//         }
//       );

//       setLinkedinVerified(true);

//       setLinkedinPicture(
//         linkedinData.profile_picture
//       );

//       setSuccessMsg(
//         "LinkedIn verified successfully"
//       );

//     } catch (err) {

//       setErrorMsg(
//         "LinkedIn verification failed"
//       );
//     }
// };
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const payload = {
//         ...formData,
//         user_id: userId,
//         consultation_fee: consultationFee,
//           linkedin_verified:
//     linkedinVerified,

//   linkedin_id:
//     linkedinId,

//   linkedin_profile_picture:
//     linkedinPicture,

//       };

//       if (existingExpert) {
//         await axios.put(`${API_URL}/api/experts/update/`, payload);
//         setSuccessMsg("Profile updated");
//       } else {
//         await axios.post(`${API_URL}/api/experts/create/`, payload);
//         setSuccessMsg("Request submitted");
//       }
//     } catch {
//       setErrorMsg("Something went wrong");
//     }
//   };

//   if (isLoading) {
//     return <Typography sx={{ mt: 5, textAlign: "center" }}>Loading...</Typography>;
//   }

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         background: `
//   linear-gradient(to bottom, #020617 0%, #020617 80px, #02061700 200px),
//   radial-gradient(circle at top, rgba(37, 99, 235, 0.15), transparent 60%),
//   #020617
// `,
//         color: "#fff",
//       }}
//     >
//       <Header1 />

//       <Container maxWidth="lg" sx={{ py: 5 }}>
//         <Typography
//           variant="h4"
//           fontWeight={700}
//           mb={4}
//           sx={{ textAlign: "center" }}
//         >
//           Expert Onboarding
//         </Typography>

//         {successMsg && <Alert severity="success">{successMsg}</Alert>}
//         {errorMsg && <Alert severity="error">{errorMsg}</Alert>}

//         <Grid container spacing={3}>
//           {/* LEFT */}
//           <Grid item xs={12} md={5}>
//             <Box display="flex" flexDirection="column" gap={3}>
              
//               {/* STEP 1 */}
//               <Paper
//                 sx={{
//                   p: 3,
//                   background: "#0f172a",
//                   borderRadius: 3,
//                   border: "1px solid rgba(255,255,255,0.1)",
//                 }}
//               >
//                 <Typography fontWeight={600} mb={2}>
//                   Step 1: Set Fee
//                 </Typography>

//                 <TextField
//                   fullWidth
//                   type="number"
//                   label="Consultation Fee (₹)"
//                   value={consultationFee}
//                   onChange={(e) => setConsultationFee(e.target.value)}
//                   InputLabelProps={{ style: { color: "#aaa" } }}
//                   InputProps={{ style: { color: "#fff" } }}
//                 />

//                 <Button
//                   variant="contained"
//                   sx={{
//                     mt: 2,
//                     background: "linear-gradient(45deg,#2563eb,#3b82f6)",
//                   }}
//                   onClick={handleSaveFee}
//                 >
//                   Save Fee
//                 </Button>
//               </Paper>

//               {/* STEP 2 */}
//               <Paper
//                 sx={{
//                   p: 3,
//                   background: "#0f172a",
//                   borderRadius: 3,
//                   border: "1px solid rgba(255,255,255,0.1)",
//                 }}
//               >
//                 <Typography fontWeight={600} mb={2}>
//                   Step 2: Availability
//                 </Typography>

//                 {isApproved ? (
//                   <ExpertAvailability
//                     consultationFee={consultationFee}
//                     setConsultationFee={setConsultationFee}
//                   />
//                 ) : (
//                   <Typography color="gray">
//                     Available after approval
//                   </Typography>
//                 )}
//               </Paper>
//             </Box>
//           </Grid>

//           {/* RIGHT */}
//           <Grid item xs={12} md={7}>
//             <Paper
//               sx={{
//                 p: 3,
//                 background: "#0f172a",
//                 borderRadius: 3,
//                 border: "1px solid rgba(255,255,255,0.1)",
//               }}
//             >
//               <Button
//   variant="contained"
//   fullWidth
//   onClick={handleLinkedInExpertVerification}
//   sx={{
//     mb: 3,
//     background:
//       "linear-gradient(45deg,#0077B5,#0A66C2)",
//     color: "white",
//     fontWeight: 600,
//   }}
// >
//   Verify & Continue with LinkedIn
// </Button> 
// {linkedinVerified && (
//   <Box
//     sx={{
//       display: "flex",
//       alignItems: "center",
//       gap: 1,
//       p: 2,
//       mb: 2,
//       borderRadius: 2,
//       background: "rgba(34,197,94,0.15)",
//       border: "1px solid rgba(34,197,94,0.4)",
//     }}
//   >
//     <img
//       src={linkedinPicture}
//       alt="linkedin"
//       width={45}
//       height={45}
//       style={{
//         borderRadius: "50%",
//       }}
//     />

//     <Box>
//       <Typography fontWeight={700}>
//         LinkedIn Verified
//       </Typography>

//       <Typography variant="body2">
//         Your expert request will get
//         priority review from admin.
//       </Typography>
//     </Box>
//   </Box>
// )}
//               <Typography fontWeight={600} mb={2}>
//                 Step 3: Profile Details
//               </Typography>

//               <TextField
//                 fullWidth
//                 name="designation"
//                 label="Designation"
//                 value={formData.designation}
//                 onChange={handleChange}
//                 sx={{ mb: 2 }}
//               />

//               <TextField
//                 fullWidth
//                 multiline
//                 rows={3}
//                 name="areas_of_expertise"
//                 label="Areas of Expertise"
//                 value={formData.areas_of_expertise}
//                 onChange={handleChange}
//                 sx={{ mb: 2 }}
//               />

//               <TextField
//                 fullWidth
//                 multiline
//                 rows={4}
//                 name="about"
//                 label="About You"
//                 value={formData.about}
//                 onChange={handleChange}
//                 sx={{ mb: 2 }}
//               />

//               <Divider sx={{ my: 2 }} />

//               <Button
//                 type="submit"
//                 variant="contained"
//                 onClick={handleSubmit}
//                 sx={{
//                   background: "linear-gradient(45deg,#2563eb,#3b82f6)",
//                   width: "100%",
//                 }}
//               >
//                 {existingExpert ? "Update Details" : "Submit Application"}
//               </Button>
//             </Paper>
//           </Grid>
//         </Grid>
//       </Container>

//       <Footer2 />
//     </Box>
//   );
// };

// export default ExpertOnboarding;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  TextField,
  Button,
  Typography,
  Grid,
  Alert,
  Divider,
  Paper,
} from "@mui/material";

import axios from "axios";

import { useAuth } from "../../AuthContext";

import Header1 from "../Header/Header1";
import Footer2 from "../Footer/Footer2";

import ExpertAvailability from "./ExpertAvailability";

const API_URL = process.env.REACT_APP_API_URL;

const ExpertOnboarding = () => {
  const { userId } = useAuth();

  const [formData, setFormData] = useState({
    designation: "",
    areas_of_expertise: "",
    about: "",
    phone: "",
    country_code: "+91",
  });

  const navigate = useNavigate();

  const [existingExpert, setExistingExpert] =
    useState(null);

  const [consultationFee, setConsultationFee] =
    useState(300);

  const [agreementChecked, setAgreementChecked] =
    useState(false);

  const [successMsg, setSuccessMsg] =
    useState("");

  const [errorMsg, setErrorMsg] =
    useState("");

  const [isLoading, setIsLoading] =
    useState(true);

  useEffect(() => {
    const fetchExpert = async () => {
      try {
        const res = await axios.post(
          `${API_URL}/api/experts/check/`,
          {
            user_id: userId,
          }
        );

        const expert = res.data;

        setExistingExpert(expert);

        setConsultationFee(
          expert.consultation_fee || 300
        );

        setFormData({
          designation:
            expert.designation || "",

          areas_of_expertise:
            expert.areas_of_expertise || "",

          about:
            expert.about || "",

          phone:
            expert.phone || "",

          country_code:
            expert.country_code || "+91",
        });
      } catch (err) {
        if (
          err.response?.status !== 404
        ) {
          setErrorMsg(
            "Error fetching data"
          );
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchExpert();
  }, [userId]);

  const isApproved =
    existingExpert?.status ===
    "approved";

  const handleChange = (e) => {
    setFormData({
      ...formData,

      [e.target.name]:
        e.target.value,
    });
  };

  const handleSaveFee = () => {
    setSuccessMsg(
      "Fee saved successfully"
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!agreementChecked) {
      setErrorMsg(
        "Please accept the agreement"
      );

      return;
    }

    try {
      const payload = {
        ...formData,

        user_id: userId,

        consultation_fee:
          consultationFee,
      };

      if (existingExpert) {
        await axios.put(
          `${API_URL}/api/experts/update/`,
          payload
        );

        setSuccessMsg(
          "Profile updated"
        );
      } else {
        await axios.post(
          `${API_URL}/api/experts/create/`,
          payload
        );

        setSuccessMsg(
          "Request submitted"
        );
      }
    } catch {
      setErrorMsg(
        "Something went wrong"
      );
    }
  };

  if (isLoading) {
    return (
      <Typography
        sx={{
          mt: 5,
          textAlign: "center",
          color: "#fff",
        }}
      >
        Loading...
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",

        background: `
linear-gradient(to bottom, #020617 0%, #020617 80px, #02061700 200px),
radial-gradient(circle at top, rgba(30,144,255,0.12), transparent 60%),
#000000
`,

        color: "#fff",
      }}
    >
      <Header1 />

      <Container
        maxWidth="lg"
        sx={{
          py: {
            xs: 4,
            md: 6,
          },

          px: {
            xs: 2,
            sm: 3,
            md: 4,
          },
        }}
      >
        {/* heading */}
        <Typography
          sx={{
            textAlign: "center",
             color: "#1E90FF",
            fontWeight: 800,

            mb: {
              xs: 4,
              md: 5,
            },

            fontSize: {
              xs: "2rem",
              sm: "2.6rem",
              md: "3rem",
            },

            lineHeight: 1.1,

            letterSpacing: "-0.04em",

            fontFamily:
              "'Bricolage Grotesque', sans-serif",
          }}
        >
          Expert Onboarding
        </Typography>

        {/* alerts */}
        {successMsg && (
          <Alert
            severity="success"
            sx={{
              mb: 3,
              borderRadius: "12px",
            }}
          >
            {successMsg}
          </Alert>
        )}

        {errorMsg && (
          <Alert
            severity="error"
            sx={{
              mb: 3,
              borderRadius: "12px",
            }}
          >
            {errorMsg}
          </Alert>
        )}

        <Grid container spacing={3}>
          {/* LEFT */}
          <Grid item xs={12} md={5}>
            <Box
              display="flex"
              flexDirection="column"
              gap={3}
            >
              {/* STEP 1 */}
              <Paper
                sx={{
                  p: {
                    xs: 2.5,
                    md: 3,
                  },

                  background:
                    "rgba(8,15,30,.95)",

                  borderRadius:
                    "22px",

                  border:
                    "1px solid rgba(30,144,255,.12)",

                  backdropFilter:
                    "blur(20px)",
                }}
              >
                <Typography
                  fontWeight={700}
                  mb={2}
                  sx={{
                    fontSize:
                      "1.05rem",
                  }}
                >
                  Step 1: Set Fee
                </Typography>

                <TextField
                  fullWidth
                  type="number"
                  label="Consultation Fee (₹)"
                  value={consultationFee}
                  onChange={(e) =>
                    setConsultationFee(
                      e.target.value
                    )
                  }
                  InputLabelProps={{
                    style: {
                      color:
                        "#9ca3af",
                    },
                  }}
                  InputProps={{
                    style: {
                      color:
                        "#fff",
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root":
                      {
                        borderRadius:
                          "14px",

                        "& fieldset":
                          {
                            borderColor:
                              "rgba(30,144,255,.2)",
                          },

                        "&:hover fieldset":
                          {
                            borderColor:
                              "rgba(30,144,255,.45)",
                          },

                        "&.Mui-focused fieldset":
                          {
                            borderColor:
                              "#1E90FF",
                          },
                      },
                  }}
                />

                <Button
                  variant="contained"
                  sx={{
                    mt: 2,

                    background:
                      "linear-gradient(90deg,#1E90FF,#42A5FF)",

                    borderRadius:
                      "12px",

                    fontWeight: 700,

                    textTransform:
                      "none",

                    px: 3,

                    py: 1.2,

                    "&:hover": {
                      background:
                        "linear-gradient(90deg,#42A5FF,#1E90FF)",
                    },
                  }}
                  onClick={
                    handleSaveFee
                  }
                >
                  Save Fee
                </Button>
              </Paper>

              {/* STEP 2 */}
              <Paper
                sx={{
                  p: {
                    xs: 2.5,
                    md: 3,
                  },

                  background:
                    "rgba(8,15,30,.95)",

                  borderRadius:
                    "22px",

                  border:
                    "1px solid rgba(30,144,255,.12)",

                  backdropFilter:
                    "blur(20px)",
                }}
              >
                <Typography
                  fontWeight={700}
                  mb={2}
                  sx={{
                    fontSize:
                      "1.05rem",
                  }}
                >
                  Step 2: Availability
                </Typography>

                {isApproved ? (
                  <ExpertAvailability
                    consultationFee={
                      consultationFee
                    }
                    setConsultationFee={
                      setConsultationFee
                    }
                  />
                ) : (
                  <Typography
                    sx={{
                      color:
                        "rgba(255,255,255,.55)",
                    }}
                  >
                    Available after
                    approval
                  </Typography>
                )}
              </Paper>
            </Box>
          </Grid>

          {/* RIGHT */}
          <Grid item xs={12} md={7}>
            <Paper
              sx={{
                p: {
                  xs: 2.5,
                  md: 3,
                },

                background:
                  "rgba(8,15,30,.95)",

                borderRadius:
                  "22px",

                border:
                  "1px solid rgba(30,144,255,.12)",

                backdropFilter:
                  "blur(20px)",
              }}
            >
              {/* heading */}
              <Typography
                fontWeight={700}
                mb={2.5}
                sx={{
                  fontSize: {
                    xs: "1rem",
                    md: "1.05rem",
                  },
                }}
              >
                Step 3: Basic Details
              </Typography>

              {/* contact row */}
              <Box
                sx={{
                  display: "grid",

                  gridTemplateColumns:
                    {
                      xs: "1fr",
                      sm: "120px 1fr",
                    },

                  gap: 2,

                  mb: 2,
                }}
              >
                <TextField
                  label="Code"
                  name="country_code"
                  value={
                    formData.country_code
                  }
                  onChange={
                    handleChange
                  }
                  fullWidth
                />

                <TextField
                  label="Contact Number"
                  name="phone"
                  value={
                    formData.phone
                  }
                  onChange={
                    handleChange
                  }
                  fullWidth
                  placeholder="9876543210"
                />
              </Box>

              <TextField
                fullWidth
                name="designation"
                label="Designation"
                value={
                  formData.designation
                }
                onChange={
                  handleChange
                }
                sx={{ mb: 2 }}
              />

              <TextField
                fullWidth
                multiline
                rows={3}
                name="areas_of_expertise"
                label="Areas of Expertise"
                value={
                  formData.areas_of_expertise
                }
                onChange={
                  handleChange
                }
                sx={{ mb: 2 }}
              />

              <TextField
                fullWidth
                multiline
                rows={4}
                name="about"
                label="About You"
                value={
                  formData.about
                }
                onChange={
                  handleChange
                }
                sx={{ mb: 2 }}
              />

              {/* shared textfield style */}
              <style>
                {`
                  .MuiOutlinedInput-root fieldset {
                    border-color: rgba(30,144,255,.18) !important;
                  }

                  .MuiOutlinedInput-root:hover fieldset {
                    border-color: rgba(30,144,255,.4) !important;
                  }

                  .MuiOutlinedInput-root.Mui-focused fieldset {
                    border-color: #1E90FF !important;
                  }

                  .MuiInputBase-input,
                  textarea {
                    color: white !important;
                  }

                  .MuiInputLabel-root {
                    color: rgba(255,255,255,.55) !important;
                  }

                  .MuiInputLabel-root.Mui-focused {
                    color: #63B8FF !important;
                  }
                `}
              </style>

              <Divider
                sx={{
                  my: 3,

                  borderColor:
                    "rgba(255,255,255,.08)",
                }}
              />

              {/* agreement */}
              <Box
                sx={{
                  mt: 1,
                  mb: 3,

                  display: "flex",

                  alignItems:
                    "flex-start",

                  gap: 1.5,

                  p: 2,

                  borderRadius:
                    "14px",

                  background:
                    "rgba(30,144,255,.05)",

                  border:
                    "1px solid rgba(30,144,255,.14)",
                }}
              >
                <input
                  type="checkbox"
                  checked={
                    agreementChecked
                  }
                  onChange={(e) =>
                    setAgreementChecked(
                      e.target.checked
                    )
                  }
                  style={{
                    marginTop:
                      "3px",

                    width: "16px",

                    height: "16px",

                    accentColor:
                      "#1E90FF",

                    cursor:
                      "pointer",
                  }}
                />

               <Typography
  sx={{
    fontSize: {
      xs: ".82rem",
      md: ".9rem",
    },

    lineHeight: 1.7,

    color:
      "rgba(255,255,255,.72)",
  }}
>
  I agree to the{" "}

  
  <Box
    component="span"
    sx={{
      color: "#63B8FF",
      cursor: "pointer",
      fontWeight: 600,

      "&:hover": {
        textDecoration:
          "underline",
      },
    }}
    onClick={() =>
      navigate("/expert-agreement")
    }
  >
    Expert User Agreement
  </Box>
  .
</Typography>
              </Box>

              {/* submit */}
              <Button
                type="submit"
                variant="contained"
                onClick={
                  handleSubmit
                }
                disabled={
                  !agreementChecked
                }
                sx={{
                  background:
                    "linear-gradient(90deg,#1E90FF,#42A5FF)",

                  width: "100%",

                  py: 1.5,

                  borderRadius:
                    "14px",

                  textTransform:
                    "none",

                  fontWeight: 700,

                  fontSize:
                    ".95rem",

                  "&:hover": {
                    background:
                      "linear-gradient(90deg,#42A5FF,#1E90FF)",
                  },

                  "&.Mui-disabled":
                    {
                      background:
                        "rgba(255,255,255,.12)",

                      color:
                        "rgba(255,255,255,.4)",
                    },
                }}
              >
                {existingExpert
                  ? "Update Details"
                  : "Submit Application"}
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      <Footer2 />
    </Box>
  );
};

export default ExpertOnboarding;